export default __webpack_public_path__ + "static/media/Highlord's Scepter.b020b65d.jpg";